<footer class="text-muted-foreground flex h-8 items-center px-4 py-2">
    <span class="truncate text-xs" data-cy="footer-copyright">{{ 'app.copyright' | translate: { year: year } }}</span>
</footer>
